import { FuseNavigationModelInterface } from '../core/components/navigation/navigation.model';

export class FuseSuperAdminNavigationModel implements FuseNavigationModelInterface
{
    public model: any[];

    constructor()
    {
        this.model = [
            {
                'id'      : 'admin',
                'title'   : 'Adminpanel',
                'translate': 'NAV.ADMIN',
                'type'    : 'group',
                'children': [
                    {
                        'id'   : 'organisations',
                        'title': 'Organisations',
                        'translate': 'NAV.ORGANISATIONS.TITLE',
                        'type' : 'item',
                        'icon' : 'group',
                        'url'  : '/organisations',
                    },
                    {
                        'id'   : 'users',
                        'title': 'Users',
                        'translate': 'NAV.USERS.TITLE',
                        'type' : 'item',
                        'icon' : 'person',
                        'url'  : '/users',
                    },
                    {
                        'id'   : 'modules',
                        'title': 'Training modules',
                        'translate': 'NAV.MODULES.TITLE',
                        'type' : 'item',
                        'icon' : 'description',
                        'url'  : '/modules',
                    }
                    ,
                    {
                        'id'   : 'progress',
                        'title': 'User progress',
                        'translate': 'NAV.PROGRESS.TITLE',
                        'type' : 'item',
                        'icon' : 'timeline',
                        'url'  : '/progress',
                    }
                ]
            }
        ];
    }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/navigation/superadmin.navigation.model.ts